/**
 * Validates that users are not streaming their own tracks for payment
 */
export function validateNotSelfStreaming(
  userId: string,
  artistId: string,
): { valid: boolean; reason?: string } {
  console.log("👤 [SELF_CHECK_VALIDATOR] Checking for self-streaming:", {
    userId,
    artistId,
  });

  if (userId === artistId) {
    console.log(
      "❌ [SELF_CHECK_VALIDATOR] Stream not eligible: Artist self-streaming",
      {
        userId,
        artistId,
      },
    );
    return {
      valid: false,
      reason: "Artist cannot stream own tracks for payment",
    };
  }

  console.log(
    "✅ [SELF_CHECK_VALIDATOR] Not self-streaming, validation passed",
  );
  return { valid: true };
}
